<div class="count app-btn-tiny_font-size g-flex g-flex--align-center g-flex--justify-center">
  {{ count }}
</div>
